// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { canSendSmsRequestToJson, canSendSmsResponseFromJson, changePhoneNumberRequestToJson, createSmsClickedEventRequestToJson, getAccountInfoRequestToJson, getAccountInfoResponseFromJson, getAreaCodeAvailabilityRequestToJson, getAreaCodeAvailabilityResponseFromJson, getLimitRequestToJson, getLimitResponseFromJson, getPhoneAndRegistrationStateRequestToJson, getPhoneAndRegistrationStateResponseFromJson, getRegulationFormsRequestToJson, getRegulationFormsResponseFromJson, listSMSEventsRequestToJson, listSMSEventsResponseFromJson, releasePhoneNumberRequestToJson, sendMessageV2RequestToJson, sendMessageV2ResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function createSmsClickedEvent(request) {
    await fetchRpc('sms.v2.SmsService/CreateSmsClickedEvent', createSmsClickedEventRequestToJson(request));
}
export function createSmsClickedEvent$(request, options) {
    return defer(() => createSmsClickedEventWithTransport$(getGlobalTransport(), request, options));
}
export function createSmsClickedEventWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.SmsService/CreateSmsClickedEvent', createSmsClickedEventRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getAccountInfo(request) {
    const raw = await fetchRpc('sms.v2.SmsService/GetAccountInfo', getAccountInfoRequestToJson(request));
    return getAccountInfoResponseFromJson(raw);
}
export function getAccountInfo$(request, options) {
    return defer(() => getAccountInfoWithTransport$(getGlobalTransport(), request, options));
}
export function getAccountInfoWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.SmsService/GetAccountInfo', getAccountInfoRequestToJson(request), options)
        .pipe(map(resp => getAccountInfoResponseFromJson(resp)));
}
export async function sendMessageV2(request) {
    const raw = await fetchRpc('sms.v2.SmsService/SendMessageV2', sendMessageV2RequestToJson(request));
    return sendMessageV2ResponseFromJson(raw);
}
export function sendMessageV2$(request, options) {
    return defer(() => sendMessageV2WithTransport$(getGlobalTransport(), request, options));
}
export function sendMessageV2WithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.SmsService/SendMessageV2', sendMessageV2RequestToJson(request), options)
        .pipe(map(resp => sendMessageV2ResponseFromJson(resp)));
}
export async function getRegulationForms(request) {
    const raw = await fetchRpc('sms.v2.SmsService/GetRegulationForms', getRegulationFormsRequestToJson(request));
    return getRegulationFormsResponseFromJson(raw);
}
export function getRegulationForms$(request, options) {
    return defer(() => getRegulationFormsWithTransport$(getGlobalTransport(), request, options));
}
export function getRegulationFormsWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.SmsService/GetRegulationForms', getRegulationFormsRequestToJson(request), options)
        .pipe(map(resp => getRegulationFormsResponseFromJson(resp)));
}
export async function getLimit(request) {
    const raw = await fetchRpc('sms.v2.SmsService/GetLimit', getLimitRequestToJson(request));
    return getLimitResponseFromJson(raw);
}
export function getLimit$(request, options) {
    return defer(() => getLimitWithTransport$(getGlobalTransport(), request, options));
}
export function getLimitWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.SmsService/GetLimit', getLimitRequestToJson(request), options)
        .pipe(map(resp => getLimitResponseFromJson(resp)));
}
export async function canSendSms(request) {
    const raw = await fetchRpc('sms.v2.SmsService/CanSendSms', canSendSmsRequestToJson(request));
    return canSendSmsResponseFromJson(raw);
}
export function canSendSms$(request, options) {
    return defer(() => canSendSmsWithTransport$(getGlobalTransport(), request, options));
}
export function canSendSmsWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.SmsService/CanSendSms', canSendSmsRequestToJson(request), options)
        .pipe(map(resp => canSendSmsResponseFromJson(resp)));
}
export async function getPhoneAndRegistrationState(request) {
    const raw = await fetchRpc('sms.v2.SmsService/GetPhoneAndRegistrationState', getPhoneAndRegistrationStateRequestToJson(request));
    return getPhoneAndRegistrationStateResponseFromJson(raw);
}
export function getPhoneAndRegistrationState$(request, options) {
    return defer(() => getPhoneAndRegistrationStateWithTransport$(getGlobalTransport(), request, options));
}
export function getPhoneAndRegistrationStateWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.SmsService/GetPhoneAndRegistrationState', getPhoneAndRegistrationStateRequestToJson(request), options)
        .pipe(map(resp => getPhoneAndRegistrationStateResponseFromJson(resp)));
}
export async function releasePhoneNumber(request) {
    await fetchRpc('sms.v2.SmsService/ReleasePhoneNumber', releasePhoneNumberRequestToJson(request));
}
export function releasePhoneNumber$(request, options) {
    return defer(() => releasePhoneNumberWithTransport$(getGlobalTransport(), request, options));
}
export function releasePhoneNumberWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.SmsService/ReleasePhoneNumber', releasePhoneNumberRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getAreaCodeAvailability(request) {
    const raw = await fetchRpc('sms.v2.SmsService/GetAreaCodeAvailability', getAreaCodeAvailabilityRequestToJson(request));
    return getAreaCodeAvailabilityResponseFromJson(raw);
}
export function getAreaCodeAvailability$(request, options) {
    return defer(() => getAreaCodeAvailabilityWithTransport$(getGlobalTransport(), request, options));
}
export function getAreaCodeAvailabilityWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.SmsService/GetAreaCodeAvailability', getAreaCodeAvailabilityRequestToJson(request), options)
        .pipe(map(resp => getAreaCodeAvailabilityResponseFromJson(resp)));
}
export async function changePhoneNumber(request) {
    await fetchRpc('sms.v2.SmsService/ChangePhoneNumber', changePhoneNumberRequestToJson(request));
}
export function changePhoneNumber$(request, options) {
    return defer(() => changePhoneNumberWithTransport$(getGlobalTransport(), request, options));
}
export function changePhoneNumberWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.SmsService/ChangePhoneNumber', changePhoneNumberRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listSMSEvents(request) {
    const raw = await fetchRpc('sms.v2.SmsService/ListSMSEvents', listSMSEventsRequestToJson(request));
    return listSMSEventsResponseFromJson(raw);
}
export function listSMSEvents$(request, options) {
    return defer(() => listSMSEventsWithTransport$(getGlobalTransport(), request, options));
}
export function listSMSEventsWithTransport$(transport, request, options) {
    return transport
        .post('sms.v2.SmsService/ListSMSEvents', listSMSEventsRequestToJson(request), options)
        .pipe(map(resp => listSMSEventsResponseFromJson(resp)));
}
